import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import * as fromActions from "./ministry.actions";
import * as fromGraphql from "./ministry.graphql";
import {getUserApprovalRosterMinistries} from "./ministry.actions";
import {GET_USER_APPROVAL_ROSTER_MINISTRIES} from "./ministry.graphql";


@Injectable()
export class MinistryEffects {
  createInstitutionMinistryMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createInstitutionMinistryMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_MINISTRY,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({data}: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertMinistry({ministry: result?.data})
              );
              this.notificationService.successMessage('Created Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), {dispatch: false});

  updateInstitutionMinistryMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateInstitutionMinistryMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_MINISTRY,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({data}: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertMinistry({ministry: result?.data})
              );
              this.notificationService.successMessage('Updated Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), {dispatch: false});

  getAllMinistries = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllMinistries),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_MINISTRIES,
        variables: {filtering: action.filtering},
        fetchPolicy: 'network-only'
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching ministries'),
        map(({data}: any) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadMinistrys({ministrys: result?.data})) : []
          }
        })
      );
    })
  ), {dispatch: false});

  getUserApprovalRosterMinistries = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getUserApprovalRosterMinistries),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_USER_APPROVAL_ROSTER_MINISTRIES,
        variables: {},
        fetchPolicy: 'network-only'
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching ministries'),
        map(({data}: any) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadMinistrys({ministrys: result?.data})) : []
          }
        })
      );
    })
  ), {dispatch: false});


  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {
  }
}
